export default {
	name: 'pesquisaCombo',
	data() {//Declaracao de variaveis
		return {
			hideNoData:true,
			timeOutCombo: null,
			tempoCombo: 250
		}
	},
	methods: {//Declaracao de todos os metodos

		pesquisaCombo(newValor, oldValor, comboObj, comboObj_eval, modelObj, fPesquisa,minCaracteres=1) {
			clearInterval(this.timeOutCombo)
			this.timeOutCombo = setTimeout(() => {
				this._pesquisaCombo(newValor, oldValor, comboObj, comboObj_eval, modelObj, fPesquisa,minCaracteres);
			}, this.tempoCombo)
		},
		_pesquisaCombo(newValor, oldValor, comboObj_, comboObj_eval, _modelObj, fPesquisa,minCaracteres=1) {
			comboObj_ = "this." + comboObj_;
			var _comboObj = comboObj_;

			if (newValor == null) return;
			if (newValor &&
				(newValor !== this.select) &&
				(newValor.length > minCaracteres) &&
				(!comboObj_eval.length)
			) {
				if (oldValor != null){
					if (oldValor.length > newValor.length) return;
				}

				fPesquisa(newValor);
				return true;
			} else {
				if (newValor.length < (minCaracteres-1)) {
					var modelObj = ("this." + _modelObj).split(".");
					var propModelObj = modelObj[modelObj.length - 1];
					comboObj_eval = (_comboObj).split(".");
					var propcomboObj = comboObj_eval[comboObj_eval.length - 1];
					this.hideNoData=true;
					this.$set(eval("this"), propcomboObj, []);
					this.$set(eval("this.model"), propModelObj, null);
				}
				return false;
			}
		},
	}
}
